import React, { CSSProperties, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';

interface Props extends TooltipProps {
    style?: CSSProperties;
    background?: 'redTooltips';
    disabled?: boolean;
}

const QuestionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem;
    border: none;
    background: none;
    outline: none;
    cursor: default;
    border-radius: 36px;
    color: #9d9d9d;
    :hover,
    :focus {
        opacity: 0.7;
    }

    svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        color: #dca45c;
    }
`;

const GStyle = createGlobalStyle`
    #redTooltips {
        z-index: 1;
        > .MuiTooltip-tooltip {
            padding: 12px;
            font-size: 12px;;
            background: red;
            max-width: unset;
            .MuiTooltip-arrow  {
                color: red;
            }
        }
    }
`;

const TooltipsWrapper = styled(Tooltip)``;

export default function TooltipInfo({ style: cssStyle, children, background, disabled = false, ...rest }: Props) {
    const [open, setOpen] = useState<boolean>(false);

    const show = () => {
        setOpen(true);
    };

    const hide = () => {
        setOpen(false);
    };

    const onClick = (e: any) => {
        e.stopPropagation();
        show();
    };
    const id = background;

    if (disabled) return children;

    return (
        <TooltipsWrapper
            {...rest}
            onMouseEnter={() => show()}
            onClick={onClick}
            onMouseLeave={() => hide()}
            open={open || false}
            id={id}
        >
            {children ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        ...cssStyle,
                    }}
                >
                    {children}
                    <GStyle />
                </div>
            ) : (
                <QuestionWrapper
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        ...cssStyle,
                    }}
                >
                    <HelpIcon />
                </QuestionWrapper>
            )}
        </TooltipsWrapper>
    );
}
